import { render, staticRenderFns } from "./superZone.vue?vue&type=template&id=35dc8c10&scoped=true&"
import script from "./superZone.vue?vue&type=script&lang=js&"
export * from "./superZone.vue?vue&type=script&lang=js&"
import style0 from "./superZone.vue?vue&type=style&index=0&id=35dc8c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dc8c10",
  null
  
)

export default component.exports